function SmallTrophyVector() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			fill="none"
			viewBox="0 0 20 20"
		>
			<g clipPath="url(#clip0_0:2298)">
				<path
					fill="#FF9100"
					d="M17.383 10.405c.499 0 .98-.144 1.403-.429A2.826 2.826 0 0019.99 7.75c.022-.452 0-.934-.066-1.472a.585.585 0 00-.656-.51c-.597.077-1.208.36-1.717.805-.024-.194-.069-.39-.11-.586.573-.278 1.016-.729 1.245-1.295.326-.785.223-1.753-.27-2.526a9.597 9.597 0 00-.876-1.18.586.586 0 00-.827-.055c-.528.463-.885 1.134-1.032 1.948-.122.727-.051 1.401.214 2.009 1.308 2.886.185 6.402-2.44 8.044-.33.211-.527.571-.527 1.008a.57.57 0 00.576.577.586.586 0 00.577-.596c.06-.037.118-.078.176-.117a2.481 2.481 0 001.652.638h.02c1.437 0 2.378-1.18 2.98-2.49a.586.586 0 00-.272-.769c-.535-.266-1.14-.343-1.837-.258.09-.179.174-.361.25-.548.111.014.223.028.332.028z"
				></path>
				<path
					fill="#FABE2C"
					d="M6.35 12.8C3.573 10.83 2.967 7.45 4.14 4.834l-.007-.003c.246-.586.313-1.242.193-1.957-.144-.806-.5-1.478-1.031-1.942a.586.586 0 00-.826.055c-.306.348-.601.745-.877 1.18-.493.773-.596 1.742-.271 2.52.229.57.672 1.021 1.243 1.3-.04.197-.076.393-.1.592-.512-.448-1.136-.733-1.734-.81a.582.582 0 00-.656.51 8.843 8.843 0 00-.067 1.462c.025.927.529 1.79 1.223 2.24a2.427 2.427 0 001.75.395c.074.182.152.361.24.537-.528-.07-1.191-.053-1.84.27a.588.588 0 00-.258.796c.203.387.445.836.742 1.237.498.726 1.314 1.223 2.277 1.223.584 0 1.145-.224 1.609-.627l.147.105.001.024a.586.586 0 101.172 0c0-.63-.4-.913-.72-1.14zM10 14.525a.586.586 0 01-.586-.585v-2.344a.586.586 0 111.172 0v2.344a.586.586 0 01-.586.585z"
				></path>
				<path
					fill="#FF9100"
					d="M10.586 13.94v-2.344A.586.586 0 0010 11.01v3.515a.586.586 0 00.586-.585z"
				></path>
				<path
					fill="#FED843"
					d="M10.006 12.182a.582.582 0 01-.16-.022 6.268 6.268 0 01-4.534-6V2.808a.585.585 0 01.876-.51c.01.006.91.51 1.761.51.615 0 1.388-.72 1.61-.973a.608.608 0 01.882 0c.222.253.995.973 1.61.973.845 0 1.75-.503 1.76-.509a.586.586 0 01.877.509v3.357a6.262 6.262 0 01-4.52 5.995.578.578 0 01-.162.023z"
				></path>
				<path
					fill="#FABE2C"
					d="M10.007 12.182a.574.574 0 00.161-.023 6.262 6.262 0 004.52-5.995V2.807a.586.586 0 00-.876-.508c-.01.005-.914.508-1.76.508-.615 0-1.388-.72-1.61-.972a.588.588 0 00-.441-.19v10.537h.006z"
				></path>
				<path
					fill="#FABE2C"
					d="M10.005 9.668a.59.59 0 01-.276-.068 3.892 3.892 0 01-2.073-3.44v-.435c0-.306.236-.56.54-.584.502-.039 1.014-.199 1.526-.474a.585.585 0 01.556 0c.512.275 1.024.435 1.526.474.304.024.54.278.54.584v.439c0 1.437-.791 2.754-2.063 3.435a.588.588 0 01-.276.07z"
				></path>
				<path
					fill="#FF9100"
					d="M10.005 9.669c.095 0 .19-.023.276-.07a3.895 3.895 0 002.063-3.435v-.438a.586.586 0 00-.54-.585c-.502-.039-1.014-.198-1.526-.473a.586.586 0 00-.278-.07v5.07h.005z"
				></path>
				<path
					fill="#646D73"
					d="M13.517 13.354H6.485a.58.58 0 00-.586.586v4.688h8.203V13.94a.58.58 0 00-.585-.586z"
				></path>
				<path
					fill="#474F54"
					d="M13.516 13.354H10v5.274h4.102V13.94a.58.58 0 00-.586-.586z"
				></path>
				<path
					fill="#FED843"
					d="M11.172 16.87H8.828a.586.586 0 110-1.172h2.344a.586.586 0 110 1.171z"
				></path>
				<path
					fill="#FABE2C"
					d="M11.172 15.698H10v1.171h1.172a.586.586 0 100-1.171z"
				></path>
				<path
					fill="#474F54"
					d="M14.688 19.213H5.313a.586.586 0 110-1.172h9.375a.586.586 0 110 1.172z"
				></path>
				<path
					fill="#32393F"
					d="M14.688 18.041H10v1.172h4.688a.586.586 0 100-1.172z"
				></path>
			</g>
			<defs>
				<clipPath id="clip0_0:2298">
					<path fill="#fff" d="M0 0H20V20H0z"></path>
				</clipPath>
			</defs>
		</svg>
	);
}

export default SmallTrophyVector;
